module.exports = __webpack_public_path__ + "static/IMG_2320-c56e575a66612ed0422f666ce3d54301.jpg";